import { actionDuckUtils } from 'wanderu-ducks-utils';

import sliceNamespace from '../../types';
import { serializeLiveCheckTripParams as serializeParams } from '../utils';

const namespace = 'LIVE_CHECK_TRIP';
const {
    actions,
    reducer,
    selectors,
} = actionDuckUtils.buildBaseDuck(namespace, sliceNamespace, serializeParams);

export {
    actions,
    namespace,
    reducer,
    selectors,
};
